module.exports = __webpack_public_path__ + "static/3.a5619ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/3.png
// module id = 825
// module chunks = 39236203315009 172526442442348